import React, { Fragment } from "react"
import config from '../../config'

export const termprivacy = () => {
	return (
		<Fragment>
			Biosci (Thailand) Co., Ltd. (company number 01355590004846 (“Biosci”,
			“we”, “us” or “our”) is committed to protecting your privacy and providing
			you with a safe and secure user experience as our client or on our
			website.
			<br />
			<br />
			Biosci (Thailand) Co., Ltd is a member of the VSN International Limited
			group of companies.
			<br />
			<br />
			For the purpose of this policy the controller of personal data is Biosci
			and our contact details are set out in the Contact section at the end of
			this Privacy Policy.
			<br />
			<br />
			This general policy also provides specific requirements relating to the
			Mixed Model Academy (MMA) or any other on-line social community operated
			by Biosci or any other member of the VSN International group of companies.
			<br />
			<br />
			By using our services, defined below, (including our website) you agree to
			the collection and use of your personal information by us in accordance
			with this Privacy Policy. If you do not agree to the terms of this Privacy
			Policy, please do not provide us with any information and do not use our
			services. This Privacy Policy sets out the basis on which we process any
			personal information we collect from you, or that you provide to us
			through the Service.
			<br />
			<br />
			<b>Right to Object:</b>
			<br />
			You have a legal right to object at any time to:
			<br />
			<ul>
				<li>use of your personal information for direct marketing purposes</li>
				<li>
					processing of your personal information which is based on our
					legitimate interests, unless there are compelling legitimate grounds
					for our continued processing.
				</li>
			</ul>
			<b>Key Changes</b>
			<ul>
				<li>
					Better navigation and user-friendly language. To make the policy
					easier to understand, we use clear, plain language and examples that
					illustrate our activities. We reformatted our privacy policy so you
					can quickly find the information that matters most to you.
				</li>
				<li>
					More control over your information. We make it easy for you to control
					the information you provide to us. Our policy explains how you can
					make choices about your information, and the measures we’ve put in
					place to keep your information secure.
				</li>
			</ul>
			<b>What This Policy Covers</b>
			<br />
			Your privacy is important to us, and so is being transparent about how we
			collect, use, and share information about you. This policy is intended to
			help you understand:
			<ol>
				<li>What information we collect about you</li>
				<li>How we use information we collect</li>
				<li>How we share information we collect</li>
				<li>How we share information we collect</li>
				<li>How to access and control your information</li>
				<li>How we transfer information we collect internationally</li>
				<li>Other important privacy information</li>
			</ol>
			We aim to satisfy the obligation of transparency under the EU General Data
			Protection Regulation 2016/679 (“GDPR”) and national laws implementing
			GDPR.
			<br />
			<br />
			This Privacy Policy covers the information we collect about you, or you
			submit to us, when you use our products or services including our website,
			or otherwise interact with us (for example, by attending our events or in
			writing), unless a different policy is displayed. We refer to all of our
			software, together with our other analytical and consulting services and
			websites as “Services” in this policy. We will ensure that the information
			we collect or you submit to us is only used for the purposes set out in
			this policy.
			<br />
			<br />
			This policy also explains your choices about how we use information about
			you. Your choices include how you can object to certain uses of
			information about you and how you can access and update certain
			information about you.
			<br />
			<br />
			Where we provide the Services under contract with an organisation (for
			example your employer) that organisation controls the information
			processed by the Services. For more information, please see the section
			headed Other Important Privacy Information below.
			<br />
			<br />
			<b>1. What Information We Collect About You</b>
			<br />
			We collect information about you when you provide it to us, and when you
			use our Services, as further described below:
			<br />
			<ol type="a">
				<li>Information you provide to us:</li>
				We collect information about you when you input it into the Services or
				otherwise provide it directly to us.
				<br />
				<br />
				<li>Account and Profile Information:</li>
				We collect information about you when you register for an account,
				create or modify your profile, set preferences, sign-up for or make
				purchases through the Services. For example, you provide your contact
				information and, we keep track of your preferences when you select
				settings within the Services.
				<br />
				<br />
				<li>Content you provide through our products:</li>
				The Services include the VSN International products you use, where we
				collect and store content that you post, send, receive and share. This
				content includes any information about you that you may choose to
				include. Examples of content we collect, and store include: your device
				details when installing and licencing software, using any online
				services and your details if you opt-in for marketing content. We
				collect content using analytics techniques (Google and cookies) and we
				collect data about how you interact with our Analytics platform and use
				features in our Services. See also Cookies and Tracking Technologies
				below.
				<br />
				<br />
				As a free user of the MMA your data, projects and model selections will
				be published for the benefit of the MMA community
				<br />
				<br />
				<li>Content you provide through our websites:</li>
				The Services also include our websites owned or operated by us. We
				collect other content that you submit to these websites, which include
				social media or social networking websites operated by us. For example,
				you provide content to us when you provide feedback or when you
				participate in any interactive features, surveys, contests, promotions,
				activities or events.
				<br />
				<br />
				<li>Information you provide through our support channels:</li>
				The Services also include our customer support, where you may choose to
				submit information regarding a problem you are experiencing with a
				Service. Whether you designate yourself as a technical contact, open a
				support ticket, speak to one of our representatives directly or
				otherwise engage with our support team, you will be asked to provide
				contact information, a summary of the problem you are experiencing, and
				any other documentation, screenshots or information that would be
				helpful in resolving the issue.
				<br />
				<br />
				<li>Payment information:</li>
				We collect payment and billing information on the webstore for the
				purpose of completing your purchase. We do not retain, hold or store any
				payment details.
				<br />
				<br />
				<li>Information we collect automatically when you use the Services:</li>
				We collect information about you when you use our Services, including
				browsing our websites and taking certain actions within the Services.
				<br />
				<br />
				<li>Your use of the Services:</li>
				We keep track of certain information about you when you visit and
				interact with any of our Services.
				<ul>
					<li>
						We use cookies and other tracking tools to record your use of our
						corporate websites and webstore.
					</li>
				</ul>
				<br />
				<li>Device and connection information:</li>
				We collect information about your computer, phone, tablet, or other
				devices you use to access the Services. This device information includes
				your connection type and settings when you access, update, or use our
				Services. We also collect information through your device about your
				operating system, browser type, IP address, URLs of referring/exit
				pages, device identifiers, and crash data. We use your IP address and/or
				country preference in order to approximate your location to provide you
				with a better Service experience. How much of this information we
				collect depends on the type and settings of the device you use to access
				the Services.
				<br />
				<br />
				<li>Cookies and other tracking technologies:</li>
				VSN International and our third-party partners, such as our development
				and analytics partners, use cookies and other tracking technologies to
				provide functionality and to recognize you across different Services and
				devices. For more information, please see our Cookie Policy, which
				includes information on how to control or opt out of these cookies and
				tracking technologies.
			</ol>
			<br />
			<b>2. How We Use Information We Collect</b>
			<br />
			How we use the information we collect depends in part on which Services
			you use, how you use them, and any preferences you have communicated to
			us. We will hold, use and disclose your personal information where it is
			necessary for the performance of our contract to provide Services to you
			or for our legitimate business purposes, as set out here:
			<br />
			<ol type="a">
				<li>To provide the Services and personalize your experience:</li>
				We use information about you to provide the Services to you, including
				to provide software, authenticate you when you log in to either the
				website or webstore, provide customer support, and operate and maintain
				the Services.
				<br />
				<br />
				<li>For research and development:</li>
				We are always looking for ways to make our Services smarter, faster,
				secure, integrated, and useful to you. We use anonymised collective
				learnings about how people use our Services and feedback provided
				directly to us to troubleshoot and to identify trends, usage, activity
				patterns and areas for integration and improvement of the Services. We
				automatically analyse and aggregate frequently used search terms to
				improve the accuracy and relevance of suggested topics that
				auto-populate when you use the search feature. In some cases, we apply
				these learnings across our Services to improve and develop similar
				features or to better integrate the services you use. We also test and
				analyse certain new features with some users before rolling the features
				out to all users.
				<br />
				<br />
				<li>To communicate with you about the Services:</li>
				We use your contact information to send transactional communications via
				email and within the Services; including responding to your comments,
				questions and requests, providing customer support, and sending you
				technical notices, updates, security alerts, and administrative
				messages. We also provide tailored communications based on your activity
				and interactions with us. We also send you communications as you onboard
				to a particular Service. Some communications are part of the Services
				and in most cases, you cannot opt out of them. If an opt out is
				available, you will find that option within the communication itself or
				in your account settings.
				<br />
				<br />
				<li>To market, promote and drive engagement with the Services:</li>
				Where you have given us permission, we use your contact information and
				information about how you use the Services to send promotional
				communications that may be of specific interest to you, including by
				email. These communications are aimed at driving engagement and
				maximising what you get out of the Services, including information about
				new software, features, survey requests, newsletters, and events we
				think may be of interest to you. We also communicate with you about new
				product offers, promotions and contests. You can control whether you
				receive these communications as described below under “Opt out of
				communications.”
				<br />
				<br />
				<li>Customer support:</li>
				We use your information to resolve technical issues you encounter, to
				respond to your requests for assistance, to analyse crash information,
				and to repair and improve the Services.
				<br />
				<br />
				<li>For safety and security:</li>
				We use information about you and your Service use to verify accounts and
				activity, to monitor suspicious or fraudulent activity and to identify
				violations of Service policies.
				<br />
				<br />
				<li>To protect our legitimate business interests and legal rights:</li>
				Where required by law or where we believe it is necessary to protect our
				legal rights, interests and the interests of others, we use information
				about you in connection with legal claims, compliance, regulatory, and
				audit functions, and disclosures in connection with the acquisition,
				merger or sale of a business.
				<br />
				<br />
				<li>With your consent:</li>
				We use information about you where you have given us consent to do so
				for a specific purpose not listed above. For example, we may publish
				testimonials or featured customer stories to promote the Services, with
				your permission.
			</ol>
			To the extent that we are processing your personal information based on
			your consent, you have the right to withdraw your consent at any time. You
			can do this by contacting us using the details in the Contact section
			below.
			<br />
			<br />
			<b>2. How We Use Information We Collect</b>
			<br />
			If you are an individual in the European Economic Area (EEA), we collect
			and process information about you only where we have legal bases for doing
			so under the GDPR. The legal bases depend on the Services you use and how
			you use them. Under the GDPR, the main grounds that we rely upon in order
			to process personal information of clients are the following:
			<ul>
				<li>
					necessary for entering into, or performing, a contract – we need it to
					provide you the Services, including to operate the Services, provide
					customer support and personalised features and to protect the safety
					and security of the Services.
				</li>
				<li>
					necessary for the purposes of legitimate interests – it satisfies a
					legitimate interest (which is not overridden by your data protection
					interests), such as for research and development, to market and
					promote the Services and to protect our legal rights and interests.
				</li>
				<li>consent – you give us consent to do so for a specific purpose.</li>
				<li>
					necessary for compliance with a legal obligation – we need to process
					your data to comply with a legal obligation.
				</li>
			</ul>
			Where we are using your information because we or a third-party (e.g. our
			developers) have a legitimate interest to do so, you have the right to
			object to that use though, in some cases, this may mean no longer using
			the services.
			<br />
			<br />
			<b>3. How We Share Information We Collect</b>
			<br />
			We develop software, and we want it to work well for you. This means
			sharing your personal information through the Services and with certain
			third parties. We share the personal information we collect about you in
			the ways discussed below, but we are not in the business of selling
			information about you to advertisers or other third parties.
			<ol type="a">
				<li>Sharing with third parties:</li>
				We share information with third parties that help us operate, provide,
				improve, integrate, customize, support and market our Services.
				<br />
				<br />
				<li>Service providers:</li>
				We work with third-party service providers to provide website and
				application development, hosting, maintenance, backup, storage, virtual
				infrastructure, payment processing, analysis and other services for us,
				which may require them to access or use information about you. If a
				service provider needs to access information about you to perform
				services on our behalf, they do so under close instruction from us,
				including policies and procedures designed to protect your information.
				<br />
				<br />
				<li>VSN International partners:</li>
				We work with third parties who provide consulting, sales, and technical
				services to deliver and implement customer solutions around the
				Services. We may share your information with these third parties in
				connection with their services, such as to assist with billing and
				collections, to provide localised support, and to provide
				customisations. We may also share information with these third parties
				where you have agreed to that sharing.
				<br />
				<br />
				We ensure that such third parties agree to comply with similar standards
				of privacy and confidentiality as those applied by VSN International
				Ltd. To the extent that any personal information is provided to third
				parties outside the EEA, or who will access the information from outside
				the EEA, we will ensure that approved safeguards are in place. We make
				use of standard contractual data protection clauses, which have been
				approved by the European Commission, and we rely on the EU-U.S. and
				Swiss-U.S. Privacy Shield Framework.
				<br />
				<br />
				<li>Social media widgets:</li>
				The Services may include links that direct you to other websites or
				services whose privacy practices may differ from ours. Your use of and
				any information you submit to any of those third-party sites is governed
				by their privacy policies, not this one.
				<br />
				<br />
				<li>Third-party widgets:</li>
				Some of our Services contain widgets and social media features, such as
				the Twitter “tweet” button. These widgets and features collect your IP
				address, which page you are visiting on the Services, and may set a
				cookie to enable the feature to function properly. Widgets and social
				media features are either hosted by a third-party or hosted directly on
				our Services. Your interactions with these features are governed by the
				privacy policy of the company providing it.
				<br />
				<br />
				<li>With your consent:</li>
				We share information about you with third parties when you give us
				consent to do so. For example, we often display personal testimonials of
				satisfied customers on our public websites. With your consent, we may
				post your name alongside the testimonial.
				<br />
				<br />
				<li>
					Compliance with enforcement requests and applicable laws; enforcement
					of our rights:
				</li>
				In exceptional circumstances, we may share information about you with a
				third-party if we believe that sharing is reasonably necessary to (a)
				comply with any applicable law, regulation, legal process or
				governmental request, including to meet national security requirements,
				(b) enforce our agreements, policies and terms of service, (c) protect
				the security or integrity of our products and services, (d) protect VSN
				International, our customers or the public from harm or illegal
				activities, or (e) respond to an emergency which we believe in good
				faith requires us to disclose information to assist in preventing the
				death or serious bodily injury of any person.
				<br />
				<br />
				<li>VSN International companies:</li>
				We share information we have about you with other VSN International
				corporate affiliates in order to operate and improve products and
				services and, as applicable with your permission, to offer other VSN
				International affiliated services to you. A list of the VSN
				International Ltd company offices can be accessed on our corporate
				website(s).
				<br />
				<br />
				For information on international transfers of your information, please
				see the section on How We Transfer Information We Collect
				Internationally below.
				<br />
				<br />
				<li>Business transfers:</li>
				We may share or transfer information we collect under this Privacy
				Policy in connection with any merger, sale of company assets, financing,
				or acquisition of all or a portion of our business to another company.
				You will be notified via email and/or a prominent notice on the Services
				if a transaction takes place, as well as any choices you may have
				regarding your information.
				<br />
				<br />
				<li>
					we share your data, projects and model selections with the MMA
					community for the sole benefit of learning by others.
				</li>
			</ol>
			<br />
			<b>4. How we store and secure information we collect</b>
			<ol type="a">
				<li>Information storage and security:</li>
				We use data hosting service providers in UK, Thailand and China to host
				the information we collect, and we use technical measures to secure your
				data.
				<br />
				<br />
				<li>How long we keep information:</li>
				How long we keep information we collect about you depends on the type of
				information, as described in further detail below. After such time, we
				will either delete or anonymise your information or, if this is not
				possible (for example, because the information has been stored in backup
				archives), then we will securely store your information and isolate it
				from any further use until deletion is possible.
				<br />
				<br />
				<li>Account information:</li>
				We retain your account information for as long as your account is active
				and a reasonable period thereafter in case you decide to re-activate the
				Services. We also retain some of your information as necessary to comply
				with our legal obligations, to resolve disputes, to enforce our
				agreements, to support business operations, and to continue to develop
				and improve our Services. Where we retain information for Service
				improvement and development, we take steps to eliminate information that
				directly identifies you, and we only use the information to uncover
				collective insights about the use of our Services, not to specifically
				analyse personal characteristics about you.
				<br />
				<br />
				<li>Information you share on the Services:</li>
				If your account is deactivated or disabled, some of your anonymised
				information and the content you have provided will remain in order to
				allow your team members or other users to make full use of the Services.
				E.g. survey data that contributes to the VSN International development
				activity.
				<br />
				<br />
				<li>Marketing information:</li>
				If you have elected to receive marketing emails from us, we retain
				information about your marketing preferences for a reasonable period of
				time from the date you last expressed interest in our Services, such as
				when you last opened an email from us or ceased using your VSN
				International account. We retain information derived from cookies and
				other tracking technologies for a reasonable period of time from the
				date such information was created.
			</ol>
			<br />
			<b>5. How To Access And Control Your Information</b>
			<br />
			You have certain rights available to you when it comes to your
			information. Below is a summary of those rights, how to exercise them and
			any limitations.
			<br />
			<br />
			Your Rights:
			<br />
			<br />
			You have the right to request a copy of your information, to object to our
			use of your information (including for marketing purposes), to request the
			deletion or restriction of your information, or to request your
			information in a structured, electronic format.
			<br />
			<br />
			Below, we describe the tools and processes for making these requests. You
			can exercise some of the choices by logging into the Services and using
			settings available within the Services or your account. For all other
			requests, you may contact us as provided in the Contact Us section below
			to request assistance.
			<br />
			<br />
			Your request and choices may be limited in certain cases: for example, if
			fulfilling your request would reveal information about another person, or
			if you ask to delete information which we or your administrator are
			permitted by law or have compelling legitimate interests to keep. If you
			have unresolved concerns, you may have the right to complain to a data
			protection authority in the country where you live, where you work or
			where you feel your rights were infringed.
			<br />
			<ol type="a">
				<li>Deactivate your account:</li>
				If you no longer wish to use our Services, you or your administrator may
				be able to deactivate your Services account. If you can deactivate your
				own account, that setting is available to you in your account settings.
				Otherwise, please contact us. If you are an administrator and are unable
				to deactivate an account through your administrator settings, please
				contact us. Please be aware that deactivating your account does not
				delete your information; your information remains visible to other
				Service users based on your past participation within the Services. For
				more information on how to delete your information, see below.
				<br />
				<br />
				<li>Delete your information:</li>
				You can delete certain information about you from within the Service by
				making a request to us. Please note, however, that we may need to retain
				certain information for record keeping purposes, to complete
				transactions or to comply with our legal obligations.
				<br />
				<br />
				<li>Request that we stop using your information:</li>
				In some cases, you may ask us to stop accessing, storing, using and
				otherwise processing your information where you believe we don’t have
				the appropriate rights to do so. For example, if you believe a Services
				account was created for you without your permission or you are no longer
				an active user, you can request that we delete your account as provided
				in this policy. Where you gave us consent to use your information for a
				limited purpose, you can contact us to withdraw that consent, but this
				will not affect any processing that has already taken place at the time.
				You can also opt-out of our use of your information for marketing
				purposes by contacting us, as provided below. When you make such
				requests, we may need time to investigate and facilitate your request.
				If there is delay or dispute as to whether we have the right to continue
				using your information, we will restrict any further use of your
				information until the request is honoured or the dispute is resolved,
				provided your administrator does not object (where applicable).
				<br />
				<br />
				<li>Opt out of communications:</li>
				You may opt out of receiving promotional communications from us by using
				the unsubscribe link within each email or by contacting us as provided
				below to have your contact information removed from our promotional
				email list or registration database. Even after you opt out from
				receiving promotional messages from us, you will continue to receive
				transactional messages from us regarding our Services.
				<br />
				<br />
				<li>Turn off Cookie Controls:</li>
				Relevant browser-based cookie controls are described in our Cookie
				Policy.
				<br />
				<br />
				<li>Send “Do Not Track” Signals:</li>
				Some browsers have incorporated “Do Not Track” (DNT) features that can
				send a signal to the websites you visit indicating you do not wish to be
				tracked. Because there is not yet a common understanding of how to
				interpret the DNT signal, our Services do not currently respond to
				browser DNT signals. You can use the range of other tools we provide to
				control data collection and use, including the ability to opt out of
				receiving marketing from us as described above.
				<br />
				<br />
				<li>Data portability:</li>
				Data portability is the ability to obtain some of your information in a
				format you can move from one service provider to another (for instance,
				when you transfer your mobile phone number to another carrier).
			</ol>
			<br />
			This right exists only in respect of personal information that:
			<ul>
				<li>you have provided to us previously.</li>
				<li>is processed by us using automated means.</li>
			</ul>
			<br />
			Should you request it, we will endeavour to provide you with an electronic
			file of your basic account information.
			<br />
			<br />
			While we are happy for such requests to be made, we are not able to
			guarantee technical compatibility with a third-party organisation’s
			systems. We are also unable to comply with requests that relate to
			personal information of others without their consent.
			<br />
			<br />
			You can exercise any of the above rights by contacting us using any of the
			methods in the Contact Us section below.
			<br />
			<br />
			Most of the above rights are subject to limitations and exceptions. We
			will provide reasons if we are unable to comply with any request for the
			exercise of your rights.
			<br />
			<br />
			<b>6. How We Transfer Information We Collect Internationally</b>
			<ol type="a">
				<li>International transfers of information we collect:</li>
				We collect information globally and primarily store that information in
				UK, Thailand and China. We transfer, process and store your information
				outside of your country of residence, to wherever we or our third-party
				service providers operate for the purpose of providing you the Services.
				Whenever we transfer your information, we take steps to protect it.
				<br />
				<br />
				<li>International transfers within the VSN International Companies:</li>
				To facilitate our global operations, we transfer information to UK,
				Thailand or China and allow access to that information from countries in
				which the VSN International owned or operated companies have operations
				for the purposes described in this policy. These countries may not have
				equivalent privacy and data protection laws to the laws of many of the
				countries where our customers and users are based. When we share
				information about you within and among VSN International corporate
				affiliates, we make use of standard contractual data protection clauses,
				which have been approved by the European Commission, and we rely on the
				EU-U.S. and Swiss-U.S. Privacy Shield Framework to safeguard the
				transfer of information we collect from the European Economic Area and
				Switzerland.
				<br />
				<br />
			</ol>
			<br />
			<b>
				7. User behaviour expected within the MMA or any other VSN International
				social community
			</b>
			<br />
			You must not load information onto MMA that is unlawful, misleading,
			discriminatory or fraudulent, or that infringes someone else's
			intellectual property or other rights.
			<br />
			<br />
			You must not upload viruses, spyware or other malicious code.
			<br />
			<br />
			We will remove content that is offensive and may also remove or flag
			content that we believe to be statistically incorrect or misleading.
			<br />
			<br />
			<b>8. Other Important Privacy Information</b>
			<ol type="a">
				<li>Administrators:</li>
				Many of our products are intended for use by organisations. Where the
				Services are made available to you through an organisation (e.g. your
				employer), that organisation is the administrator of the Services and is
				responsible for the accounts and/or Service sites over which it has
				control. If this is the case, please direct your data privacy questions
				to your administrator, as your use of the Services is subject to that
				organisation’s policies. We are not responsible for the privacy or
				security practices of an administrator’s organisation, which may be
				different than this policy.
				<br />
				<br />
				Administrators are able to:
				<ul>
					<li>require you to reset your account password.</li>
					<li>restrict, suspend or terminate your access to the Services.</li>
					<li>access information in and about your account.</li>
					<li>access or retain information stored as part of your account.</li>
					<li>install or uninstall third-party apps or other integrations.</li>
				</ul>
				<br />
				In some cases, administrators can also:
				<ul>
					<li>restrict, suspend or terminate your account access.</li>
					<li>change the email address associated with your account.</li>
					<li>change your information, including profile information.</li>
					<li>
						restrict your ability to edit, restrict, modify or delete
						information.
					</li>
				</ul>
				<br />
				Even if the Services are not currently administered to you by an
				organisation, if you use an email address provided by an organisation
				(such as your work email address) to access the Services, then the owner
				of the domain associated with your email address (e.g. your employer)
				may assert administrative control over your account and use of the
				Services at a later date. You will be notified if this happens.
				<br />
				<br />
				If you do not want an administrator to be able to assert control over
				your account or use of the Services, use your personal email address to
				register for or access the Services. If an administrator has not already
				asserted control over your account or access to the Services, you can
				update the email address associated with your account through your
				account settings in your profile. Once an administrator asserts control
				over your account or use of the Services, you will no longer be able to
				change the email address associated with your account without
				administrator approval.
				<br />
				<br />
				Please contact your organization or refer to your administrator’s
				organizational policies for more information.
				<br />
				<br />
				<li>Our policy towards children:</li>
				The Services are not directed to individuals under 16. We do not
				knowingly collect personal information from children under 16. If we
				become aware that a child under 16 has provided us with personal
				information, we will take steps to delete such information. If you
				become aware that a child has provided us with personal information,
				please contact our support services.
				<br />
				<br />
				<li>Changes to our Privacy Policy:</li>
				We may change this Privacy Policy from time to time. We will post any
				Privacy Policy changes on this page and, if the changes are significant,
				we will provide a more prominent notice by adding a notice on the
				Services homepages, login screens, or by sending you an email
				notification. We will also keep prior versions of this Privacy Policy in
				an archive for your review. We encourage you to review our Privacy
				Policy whenever you use the Services to stay informed about our
				information practices and the ways you can help protect your privacy.
				<br />
				<br />
				If you disagree with any changes to this Privacy Policy, you will need
				to stop using the Services and deactivate your account(s), as outlined
				above.
				<br />
				<br />
				<li>Internet-based transfers:</li>
				Given that the Internet is a global environment, using the Internet to
				collect and process personal data necessarily involves the transmission
				of data on an international basis. Unfortunately the transmission of
				information via the internet is not completely secure. Although we will
				do our best to protect your personal data, we cannot guarantee the
				security of your data transmitted to our site via third-party networks;
				any transmission is at your own risk. Once we have received your
				information, we will use strict procedures and security features to try
				to prevent unauthorised access.
				<br />
				<br />
				<li>Complaints:</li>
				If you are unhappy about our use of your personal information, you can
				contact us using the details in the Contact Us section below. You are
				also entitled to lodge a complaint with the UK Information
				Commissioner’s Office using any of the below contact methods:
				<br />
				<br />
				Telephone: 0303 123 11113
				<br />
				<br />
				Website: https://ico.org.uk/concerns/
				<br />
				<br />
				Post: Information Commissioner’s Office
				<br />
				Wycliffe House
				<br />
				Water Lane
				<br />
				Wilmslow
				<br />
				Cheshire
				<br />
				SK9 5AF
				<br />
				<br />
				If you live or work outside of the UK or you have a complaint concerning
				our activities outside of the UK, you may prefer to lodge a complaint
				with a different supervisory authority.
				<br />
				<br />
				<li>Contact Us:</li>
				Your information is controlled by Biosci (Thailand) Co., Ltd. If you
				have any enquires or if you would like to contact us about our
				processing of your personal information, including exercising your
				rights as outlined above, please contact your local VSN International
				office or contact us centrally by any of the methods below.
				<br />
				<br />
				When you contact us, we will ask you to verify your identity.
				<br />
				<br />
				Contact name: Data Protection Officer
				<br />
				Email: {config.emailsupport}
				<br />
				Telephone: Tel: +66 (0) 2564 7757
				<br />
				<br />
				Our registered office is at:
				<br />
				Biosci (Thailand) Co., Ltd.
				<br />
				131 Thailand Science Park,
				<br />
				Innovation Cluster 1 Building,
				<br />
				Suite no. INC1-311, 3<sup>rd</sup> Floor, Moo 9,
				<br />
				Paholyothin Road, Klong Neung Sub-District,
				<br />
				Klong Luang District, Pathumthani 12120
				<br />
				Thailand
			</ol>
		</Fragment>
	)
}
